import { StateCreator } from 'zustand';
import { GameCardData } from '@/features/games/internal/types/game-card-data';

const MAX_CONTINUE_TO_PLAY_GAMES = 12;

type ContinueToPlayEntry = GameCardData & { lastPlayedAt: number };

export interface GameCardsSlice {
  continueToPlayGameCards: Record<number, ContinueToPlayEntry>;
  setContinueToPlayGameCard: (card: GameCardData) => void;
}

const getRecency = (card: ContinueToPlayEntry) => card.lastPlayedAt ?? 0;
const sortByRecency = (cards: ContinueToPlayEntry[]) =>
  cards.sort((a, b) => getRecency(b) - getRecency(a));

export const createContinueToPlayGameCardsSlice: StateCreator<GameCardsSlice> = (set) => ({
  continueToPlayGameCards: {},

  setContinueToPlayGameCard: (card) =>
    set((state) => {
      const lastPlayedAt = Date.now();
      const updatedCards: Record<number, ContinueToPlayEntry> = {
        ...state.continueToPlayGameCards,
        [card.id]: { ...card, lastPlayedAt },
      };

      const limitedCards = sortByRecency(Object.values(updatedCards))
        .slice(0, MAX_CONTINUE_TO_PLAY_GAMES)
        .reduce<Record<number, ContinueToPlayEntry>>((acc, entry) => {
          acc[entry.id] = entry;
          return acc;
        }, {});

      return { continueToPlayGameCards: limitedCards };
    }),
});
